import { Component, ElementRef, ViewChild, Renderer2, HostListener, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'bb-drag-selector',
	templateUrl: './bb-drag-selector.component.html',
	styleUrls: ['./bb-drag-selector.component.scss']
})

export class BbDragSelectorComponent implements OnInit, OnDestroy {
	@ViewChild('dragSelector', { static: true }) dragSelector: ElementRef;

	@Output() selectDragStart: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectDragging: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectDragEnd: EventEmitter<any> = new EventEmitter<any>();

	private x1 = 0;
	private y1 = 0;
	private x2 = 0;
	private y2 = 0;
	private dragSelect = false;

	constructor(private renderer: Renderer2) { }

	@HostListener('mousedown', ['$event'])
	onMouseDown(e: MouseEvent): void {
		if (e.button !== 0) {
			return;
		}
		this.selectDragStart.emit();

		this.x2 = 0;
		this.y2 = 0;

		this.dragSelect = true;
		this.renderer.setStyle(this.dragSelector.nativeElement, 'visibility', 'visible');

		// get parent element position in document
		this.x2 = this.x1 = e.offsetX; // Set the initial X
		this.y2 = this.y1 = e.offsetY; // Set the initial Y

		this.reCalc();
	}

	@HostListener('mousemove', ['$event'])
	onMouseMove(e: MouseEvent): void {
		if (!this.dragSelect) {
			return;
		}
		this.x2 = e.offsetX; // Update the current position X
		this.y2 = e.offsetY; // Update the current position Y
		this.reCalc();
	}

	@HostListener('mouseup')
	onMouseUp(e: MouseEvent): void {
		if (!this.dragSelect) {
			return;
		}
		this.selectDragEnd.emit();
		this.dragSelect = false;
		this.renderer.setStyle(this.dragSelector.nativeElement, 'visibility', 'hidden');
	}

	ngOnInit() {
		this.renderer.setStyle(this.dragSelector.nativeElement, 'visibility', 'hidden');
	}

	ngOnDestroy() { }

	private reCalc(): void {
		const x3 = Math.min(this.x1, this.x2); // Smaller X
		const x4 = Math.max(this.x1, this.x2); // Larger X
		const y3 = Math.min(this.y1, this.y2); // Smaller Y
		const y4 = Math.max(this.y1, this.y2); // Larger Y
		this.renderer.setStyle(this.dragSelector.nativeElement, 'left', x3 + 'px');
		this.renderer.setStyle(this.dragSelector.nativeElement, 'top', y3 + 'px');
		this.renderer.setStyle(this.dragSelector.nativeElement, 'width', (x4 - x3) + 'px');
		this.renderer.setStyle(this.dragSelector.nativeElement, 'height', (y4 - y3) + 'px');

		this.selectDragging.emit({ x: x3, y: y3, width: (x4 - x3), height: (y4 - y3) });
	}
}
